module.exports = __webpack_public_path__ + "img/bg-top.03839d7a.jpg";